import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LoginRegisterFormModule } from '@apps/gc-login/register-form/login-register-form.module';
import {
  AdvertisementModule,
  BottomSheetModule,
  ColorModule,
  DesktopDetectGuard,
  DownloadAppModule,
  EventBannerModule,
  FeedGridModule,
  FeedPostsModule,
  GoBackModule,
  MillifyModule,
  MipAlertModule,
  MipAvatarModule,
  MipCardModule,
  MipIconModule,
  MipLoadingModule,
  MipModalModule,
  MipProfileSlugNameModule,
  MipSeeMoreModule,
  MipToolbarModule,
  MipTranslateModule,
  OnReachingBottomModule,
  ProfileFollowingButtonModule,
  ProfileOptionsModule,
  ScrollFixModule,
  ShareModalModule,
  UsersListModule,
  StoriesSliderModule
} from '@lib/gc-common';
import { TranslateModule } from '@ngx-translate/core';
import { TruncateModule } from '@yellowspot/ng-truncate';
import { SwiperModule } from 'swiper/angular';

import { ProfileBadgesComponent } from './profile-badges/profile-badges.component';
import { ProfileEditComponent } from './profile-edit/profile-edit.component';
import { ProfileFeedComponent } from './profile-feed/profile-feed.component';
import { ProfileHeaderComponent } from './profile-header/profile-header.component';
import { ProfilePublicActionsComponent } from './profile-header/profile-public-actions/profile-public-actions.component';
import { ProfileUserActionsComponent } from './profile-header/profile-user-actions/profile-user-actions.component';
import { ProfileListProfilesComponent } from './profile-info/profile-followers/profile-list-profiles.component';
import { ProfileInfoComponent } from './profile-info/profile-info.component';
import { ProfileInvitationComponent } from './profile-invite/profile-invitation/profile-invitation.component';
import { ProfileInviteComponent } from './profile-invite/profile-invite.component';
import { ProfileReactionsComponent } from './profile-reactions/profile-reactions.component';
import { ProfileRedirectEventComponent } from './profile-redirect-event/profile-redirect-event.component';
import { ProfileRoutingModule } from './profile-routing.module';
import { ProfileStoriesComponent } from './profile-stories/profile-stories.component';
import { ProfileTopToolbarComponent } from './profile-top-toolbar/profile-top-toolbar.component';
import { ProfileComponent } from './profile.component';

@NgModule({
  declarations: [
    ProfileComponent,
    ProfileHeaderComponent,
    ProfileBadgesComponent,
    ProfileEditComponent,
    ProfileFeedComponent,
    ProfileUserActionsComponent,
    ProfilePublicActionsComponent,
    ProfileListProfilesComponent,
    ProfileInfoComponent,
    ProfileInviteComponent,
    ProfileInvitationComponent,
    ProfileRedirectEventComponent,
    ProfileTopToolbarComponent,
    ProfileReactionsComponent,
    ProfileStoriesComponent,
  ],
  imports: [
    CommonModule,
    ProfileRoutingModule,
    MatToolbarModule,
    MatGridListModule,
    MipProfileSlugNameModule,
    MipIconModule,
    MipAvatarModule,
    FeedGridModule,
    HttpClientModule,
    ColorModule,
    MatIconModule,
    MatCardModule,
    MatBottomSheetModule,
    MatListModule,
    MipModalModule,
    MipCardModule,
    MipToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    FeedPostsModule,
    AdvertisementModule,
    BottomSheetModule,
    MatButtonModule,
    GoBackModule,
    MipTranslateModule,
    DownloadAppModule,
    MatMenuModule,
    TruncateModule,
    ShareModalModule,
    MipLoadingModule,
    MatTabsModule,
    TranslateModule,
    OnReachingBottomModule,
    SwiperModule,
    MipAlertModule,
    MatSelectModule,
    ProfileFollowingButtonModule,
    ProfileOptionsModule,
    EventBannerModule,
    UsersListModule,
    MillifyModule,
    ScrollFixModule,
    MipSeeMoreModule,
    LoginRegisterFormModule,
    StoriesSliderModule,
    StoriesSliderModule,
  ],
  providers: [DesktopDetectGuard],
  exports: [
    ProfileStoriesComponent
  ]
})
export class ProfileModule {
}
